import type { SVGProps } from 'react';
import * as React from 'react';

export const PauseCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.33268 0.333008C1.41221 0.333008 0.666016 1.0792 0.666016 1.99967V11.9997C0.666016 12.9201 1.41221 13.6663 2.33268 13.6663H3.99935C4.91982 13.6663 5.66602 12.9201 5.66602 11.9997V1.99967C5.66602 1.0792 4.91982 0.333008 3.99935 0.333008H2.33268Z"
      fill="white"
    />
    <path
      d="M8.99935 0.333008C8.07887 0.333008 7.33268 1.0792 7.33268 1.99967V11.9997C7.33268 12.9201 8.07887 13.6663 8.99935 13.6663H10.666C11.5865 13.6663 12.3327 12.9201 12.3327 11.9997V1.99967C12.3327 1.0792 11.5865 0.333008 10.666 0.333008H8.99935Z"
      fill="white"
    />
  </svg>
);
